import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Integrations() {
  return (
    <>
      <Helmet>
        <title>Integrations - Aramco Leads Pro</title>
        <meta name="description" content="Integrate Aramco Leads Pro with your existing tools via API. Connect your CRM with other business applications." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Integrations</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Connect with your existing tools</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1rem' }}>API Integration</h2>
          <p style={{ fontSize: '1.1rem', color: '#6b7280', maxWidth: '600px', margin: '0 auto' }}>
            Aramco Leads Pro provides a RESTful API to integrate with your existing business tools and workflows.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
          {[
            { icon: '🔗', title: 'RESTful API', desc: 'Full API access for custom integrations' },
            { icon: '🔔', title: 'Webhooks', desc: 'Real-time event notifications' },
            { icon: '📊', title: 'Data Export', desc: 'Export your data anytime' },
            { icon: '🔐', title: 'Secure Access', desc: 'API keys and OAuth 2.0 support' }
          ].map((item, idx) => (
            <div key={idx} style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{item.icon}</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>{item.title}</h3>
              <p style={{ color: '#6b7280' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
